// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"637":"order","5149":"invoice","7824":"analytics-edit","8386":"order-detail"}[chunkId] + "." + {"637":"02e08e12","5149":"832966e8","7824":"7aec6446","8386":"da0306c5"}[chunkId] + ".css";
};